import { pharmacyClient } from "@/connect";
import { GetInventoryResponse } from "@/gen/inventory/get_inventory_pb";

export const getExpiryList = async (
  page: number,
  pageSize: number
): Promise<GetInventoryResponse> => {
  return await pharmacyClient.getInventory({
    page,
    pageSize,
    filter: {
      isExpired: true,
      expiringSoonDays: 30,
    }
  });
};